import store from "@/store/index.js";

export default [
  {
    path: "/newlyAdded",
    name: "newlyAdded",
    meta: { requiresAuth: true },
    component: () => import("@/views/NewlyAdded.vue"),
    children: [
      {
        path: "news-all",
        name: "newlyAddedNewsAll",
        meta: { requiresAuth: true },
        component: () => import("@/components/NewlyAdded/NewsAll.vue"),
        beforeEnter: async (to, from, next) => {
          store.commit("initPagination");
          await store.dispatch("fetchNewlyAddedNewsAll");
          next();
        }
      },
      {
        path: "oneNews-read/:oneNewsId",
        name: "newlyAddedOneNewsRead",
        meta: { requiresAuth: true },
        component: () => import("@/components/NewlyAdded/OneNewsRead.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneNews", to.params.oneNewsId);
          next();
        }
      },
      {
        path: "survey-all",
        name: "newlyAddedSurveyAll",
        meta: { requiresAuth: true },
        component: () => import("@/components/NewlyAdded/SurveyAll.vue"),
        beforeEnter: async (to, from, next) => {
          store.commit("initPagination");
          await store.dispatch("fetchNewlyAddedSurveyAll");
          next();
        }
      },
      {
        path: "oneSurvey-read/:oneSurveyId",
        name: "newlyAddedOneSurveyRead",
        meta: { requiresAuth: true },
        component: () => import("@/components/NewlyAdded/OneSurveyRead.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneSurvey", to.params.oneSurveyId);
          next();
        }
      }
    ]
  }
];
